export interface PainterState {
   painterType: any;
   paintedDays: Array<any>;
   painterInfo: any;
   dragging: boolean;
}

const state: PainterState = {
   painterType: null,
   paintedDays: [],
   painterInfo: {
      lastValidContracts: [],
   },
   dragging: false,
};

const getters = {
   painterType(state: PainterState) {
      return state.painterType;
   },
};

const mutations = {
   SET_PAINTER_TYPE(state: any, painterType: string) {
      state.painterType = painterType;
   },
   SET_PAINTED_DAYS(state: any, paintedDays: Array<any>) {
      state.paintedDays = paintedDays;
   },
   SET_PAINTED_DAY(state: any, paintedDay: any) {
      const matcher = ({ date, companyId, employeeId }: any) =>
         date === paintedDay.date && companyId === paintedDay.companyId && employeeId === paintedDay.employeeId;

      const match = !!state.paintedDays.find(matcher);
      if (!match) state.paintedDays = [...state.paintedDays, paintedDay];
      else state.paintedDays = state.paintedDays.filter((day: any) => !matcher(day));
   },
   CHANGE_PAINTED_DAY(state: any, paintedDay: any) {
      const index = state.paintedDays.findIndex(
         (pd: any) => pd.date === paintedDay.date && pd.companyId === paintedDay.companyId && pd.employeeId === paintedDay.employeeId,
      );

      if (index > -1) state.paintedDays.splice(index, 1, paintedDay);
   },
   SET_PAINTER_INFO(state: any, painterInfo: any) {
      state.painterInfo = painterInfo;
   },
   SET_DRAGGING(state: any, dragging: boolean) {
      state.dragging = dragging;
   },
};

const actions = {};

export default {
   namespaced: true,
   state,
   getters,
   actions,
   mutations,
};
